module.exports = __webpack_public_path__ + "img/p3_1.13cc1ff8.webp";